package com.example.mystybag.sharedmodels.base

import com.example.mystybag.sharedmodels.ModelsData
import kotlinx.serialization.Polymorphic
import kotlinx.serialization.Serializable

enum class UsageInProduct {
    MYSTYBAG,
    ALL
}

enum class StringUsageInProduct {
    ALL,
}

enum class StringUsageFilter {
    COMMON
}

enum class TypeOfChangeInAdmin {
    INSERT,
    UPDATE,
    DELETE
}

enum class CampaignObjectTypes {
    BANNERS
}

enum class CampaignFilter {
    ANY,
    ACTIVE,
    INACTIVE
}

enum class NotificationStatus {
    ADDED,
    SENT
}

@Polymorphic
@Serializable
open class BaseRequestModel(
    val api                     : String    = "",
    var version                 : String    = ModelsData.version,
    var versionName             : String    = ModelsData.versionName,
    var ip                      : String    = ModelsData.ip,
    var os                      : Int       = ModelsData.os,
    var language                : String    = ModelsData.language,
    var osVersionCode           : String    = ModelsData.osVersionCode,
    var resourceId              : String    = ModelsData.resourceId,
    val deviceModel             : String    = ModelsData.deviceModel,
    var timestamp               : String    = ""
)